import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { HANDBOOK_TABLE_OF_CONTENT_CONVERTER_TOKEN, HandBookTableOfContentConverter } from './handbook-table-of-content.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        handbookTableOfContentFeature: {
          module: () => import('./handbook-table-of-content.module').then((m) => m.HandbookTableOfContentModule),
          cmsComponents: ['macs_handbook_toc'],
        },
      }
    }),
    {
      provide: HANDBOOK_TABLE_OF_CONTENT_CONVERTER_TOKEN,
      useExisting: HandBookTableOfContentConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        macs_handbook_toc: HANDBOOK_TABLE_OF_CONTENT_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class HandbookTableOfContentFeatureModule {}
